import React from 'react';
import isEmpty from 'lodash/isEmpty';

import './HeadInfo.scss';

function HeadInfo({ offerTitle, clickUrl, assets: { text, callToActionText } }) {
  if (isEmpty(clickUrl)) {
    return (
      <div className="mn_headInfo">
        <h2
          dangerouslySetInnerHTML={{ __html: offerTitle }}
        />
      </div>
    );
  }

  return (
    <div className="mn_headInfo">
      {/* eslint-disable-next-line jsx-a11y/control-has-associated-label */}
      <a
        href={clickUrl}
        className="mn_dynamicMarketingTextLink"
        target="_blank"
        title="Opens a new window"
        dangerouslySetInnerHTML={{ __html: text }}
      />
      <span className="mn_buttonWrap">
        {/* eslint-disable-next-line jsx-a11y/control-has-associated-label */}
        <a
          data-test="marketing-text-button"
          href={clickUrl}
          className="mn_button"
          target="_blank"
          title="Opens in new window"
          dangerouslySetInnerHTML={{ __html: callToActionText || 'Shop now' }}
        />
      </span>
    </div>
  );
}

export default HeadInfo;
